import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import tick from "../../assets/img/about/tick.svg";
import bin from "../../assets/img/about/bin.svg";
import { useAlert } from "./context/AlertContext";

const API_HOST = process.env.REACT_APP_API_URL;

// -------------------
// Login Component
// -------------------
function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    // If authToken exists in session storage, redirect to the admin dashboard
    if (sessionStorage.getItem("authToken")) {
      const userType = sessionStorage.getItem("userType");
      if (userType === "blogger") {
        navigate("/blogger");
      } else if (userType === "admin") {
      navigate("/admin/admin-dashboard");
      }
      else if(userType === "blogHead"){
         navigate("/blogHead/blogs");
      }
    }
  }, [navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await fetch(`${API_HOST}auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (data.success) {
        sessionStorage.setItem("authToken", data.authToken);
        sessionStorage.setItem("userType", data.userType);
       
        if (data.userType === "admin") {
          navigate("/admin/admin-dashboard");
        } else if (data.userType === "blogger") {
          navigate("/blogger/"); // or your actual blogger route
        }else if(data.userType === "blogHead"){
         navigate("/blogHead/blogs");
      }
         else {
          setError("Unknown user type.");
          sessionStorage.removeItem("authToken");
        
        }

      } else {
        setError("Invalid credentials, please try again.");
      }
    } catch (error) {
      console.error("Error logging in:", error);
      setError("Something went wrong. Please try again later.");
    }
  };

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        className="mb-20 mt-20"
        style={{
          width: "400px",
          padding: "40px",
          margin: "auto",
          border: "1px solid rgba(131, 131, 131, 0.5)",
          backgroundColor: "rgba(255, 255, 255, 0.1)",
          borderRadius: "8px",
        }}
      >
        <form className="contact-form pos-rel" onSubmit={handleSubmit}>
          <div className="row">
            <h3>Admin Login</h3>
            {error && <p style={{ color: "red" }}>{error}</p>}
            <div className="col-lg-12">
              <div
                className="xb-item--field"
                style={{
                  borderTop: "0",
                  borderBottom: "1px solid rgba(131, 131, 131, 0.5)",
                }}
              >
                <label htmlFor="mail">Email</label>
                <input
                  id="mail"
                  type="email"
                  placeholder="genz@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className="col-lg-12">
              <div
                className="xb-item--field"
                style={{
                  borderTop: "0",
                  borderBottom: "1px solid rgba(131, 131, 131, 0.5)",
                }}
              >
                <label htmlFor="pwd">Password</label>
                <input
                  id="pwd"
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
            </div>
            <button type="submit" className="circle-btn port-btn">
              <span className="button__bg"></span>Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

// -------------------
// AdminDashboard Component
// -------------------
function AdminDashboard() {
  const [adminName, setAdminName] = useState("Jatin Gupta");
  const [enquiries, setEnquiries] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filter, setFilter] = useState("all");
  const navigate = useNavigate();
  const isMounted = useRef(false);
  const fetchCount = useRef(0);
    const showAlert = useAlert();

  const currentYear = new Date().getFullYear();
  const currentMonth = `${currentYear}-${(new Date().getMonth() + 1)
    .toString()
    .padStart(2, "0")}`;


  const [viewstats, setViewstats] = useState({
    totalViews: 0,
    yearlyViews: {},
    monthlyViews: {},
    dailyViews: {},
  });

 
  const computeLast7DaysViews = (dailyViews) => {
    let sum = 0;
    let referrerStats = {};

    if (dailyViews) {
      const today = new Date();

      Object.keys(dailyViews).forEach((dayKey) => {
        const dayDate = new Date(dayKey);
        const diffTime = today - dayDate;
        const diffDays = diffTime / (1000 * 60 * 60 * 24);

        if (diffDays >= 0 && diffDays < 7) {
          sum += dailyViews[dayKey].total || 0;

          // Aggregate referrer stats
          const referrals = dailyViews[dayKey].referrals || {};
          Object.keys(referrals).forEach((referrer) => {
            referrerStats[referrer] =
              (referrerStats[referrer] || 0) + referrals[referrer];
          });
        }
      });
    }

    return { sum, referrerStats };
  };

  useEffect(() => {
    if (isMounted.current) {
      console.log("useEffect prevented re-run");
      return;
    }
    isMounted.current = true;

    // Fetch view stats
    fetch(`${API_HOST}views/stats`)
      .then((res) => res.json())
      .then((data) => setViewstats(data))
      .catch((err) => console.error("Error fetching stats:", err));

    const fetchAdminData = async () => {
      fetchCount.current++;
      console.log("Fetching data, attempt:", fetchCount.current);
      setLoading(true);

      const authToken = sessionStorage.getItem("authToken");
      const userType =  sessionStorage.getItem("userType");
      if(!userType || userType !== "admin") {
        setError("Unauthorized access. Please log in.");
        navigate("/admin/login");
        return;
      }
      if (!authToken ) {
        setError("Unauthorized access. Please log in.");
        navigate("/admin/login");
        return;
      }

      try {
        const enquiriesResponse = await fetch(
          `${API_HOST}contact/all-enquiries`,
          {
            method: "GET",
            headers: { "auth-token": authToken },
          }
        );

        if (!enquiriesResponse.ok) {
          throw new Error(`HTTP error ${enquiriesResponse.status}`);
        }
        const enquiriesData = await enquiriesResponse.json();
        setEnquiries(enquiriesData.enquiries);
        calculateStats(enquiriesData.enquiries);
      } catch (err) {
        console.error("Error fetching data:", err);
        setError("Error in fetching data. Please try again later");
      } finally {
        setLoading(false);
      }
    };

    fetchAdminData();
  }, [navigate]);

  const calculateStats = (enquiries) => {
    const totalEnquiries = enquiries.length;
    const closedLeads = enquiries.filter((e) => e.leadClosed).length;
    const openLeads = totalEnquiries - closedLeads;
    const now = new Date();
    const startOfYear = new Date(now.getFullYear(), 0, 1);
    const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    const last7Days = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() - 7
    );

    const leadsThisYear = enquiries.filter(
      (e) => new Date(e.date) >= startOfYear
    ).length;
    const leadsThisMonth = enquiries.filter(
      (e) => new Date(e.date) >= startOfMonth
    ).length;
    const leadsLast7Days = enquiries.filter(
      (e) => new Date(e.date) >= last7Days
    ).length;

    setStats({
      totalEnquiries,
      closedLeads,
      openLeads,
      leadsThisYear,
      leadsThisMonth,
      leadsLast7Days,
    });
  };

  const handleAction = (id, action) => {
    const authToken = sessionStorage.getItem("authToken");
    const endpoint =
      action === "close"
        ? `contact/closelead/${id}`
        : `contact/deletelead/${id}`;

    fetch(`${API_HOST}${endpoint}`, {
      method: "PUT",
      headers: { "auth-token": authToken },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data.success) {
          let message= (action === "close") ? "Lead Closed Successfully": "Lead Deleted Successfully";
          let messageType= (action === "close") ? "success": "danger";
          showAlert(message, messageType);
          if (action === "close") {
            setEnquiries((prev) =>
              prev.map((enquiry) =>
                enquiry._id === id ? { ...enquiry, leadClosed: true } : enquiry
              )
            );
            let imgElement = document.getElementById(`close-lead-${id}`);
            if (imgElement) {
              imgElement.style.display = "none";
            }
          } else {
            setEnquiries((prev) =>
              prev.filter((enquiry) => enquiry._id !== id)
            );
            let selectedTr = document.getElementById(`unique-tr-${id}`);
            if (selectedTr) {
              selectedTr.style.display = "none";
            }
          }
        }
      })
      .catch((error) => {
        console.error(`Error with ${action} action:`, error);
      });
  };

  if (loading) {
    return (
      <div style={{ height: "80vh" }}>
        Hi Admin! I Hope you are Doing Well! Loading...
      </div>
    );
  }

  if (error) {
    return <div style={{ height: "80vh", flex: "1" }}>{error}</div>;
  }

  if (!stats) {
    return (
      <div style={{ height: "80vh", flex: "1" }}>
        Error in fetching data. Please try again later.
      </div>
    );
  }

  const filteredEnquiries = enquiries.filter((enquiry) => {
    if (filter === "all") return true;
    if (filter === "open") return !enquiry.leadClosed;
    if (filter === "closed") return enquiry.leadClosed;
    return true;
  });

  return (
    <div className="admin-dashboard-container container">
      <div className="dashboard-header">
        <h1>Welcome, {adminName}</h1>
        <div className="flex justify-content-between"  style={{
                       
                       padding: "8px",
                       display: "flex",
                       gap: "10px",
                     }}>
         <button
           className="logout-button"
           onClick={()=>{
            navigate("/admin/blogs");
           }}
         >
           Blog Section
         </button>
         <button
                            className="logout-button"
                            onClick={() => {
                                navigate("/admin/users");
                            }}
                        >
                            Users
                        </button>
         <button
           onClick={() => {
             sessionStorage.removeItem("authToken");
              sessionStorage.removeItem("userType");
             navigate("/admin/login");
           }}
           className="logout-button"
         >
           Logout
         </button>
         </div>
      </div>
      {/* {enquiries.length > 0 && ( */}
        <>
          <div className="row stats-container">
            {/* Total Views */}
            <div className="stats-card">
              <span className="stat-value">{viewstats.totalViews}</span>
              <br />
              <span className="stat-label">Total Views</span>
            </div>

            {/* Views This Year */}
            <div className="stats-card">
              <span className="stat-value">
                {viewstats.yearlyViews[currentYear] || 0}
              </span>
              <br />
              <span className="stat-label">Views This Year</span>
            </div>

            {/* Views This Month */}
            <div className="stats-card">
              <span className="stat-value">
                {viewstats.monthlyViews[currentMonth] || 0}
              </span>
              <br />
              <span className="stat-label">Views This Month</span>
            </div>

            {/* Views Last 7 Days (Calculated Dynamically) */}
            <div className="stats-card">
              <span className="stat-value">
                {computeLast7DaysViews(viewstats.dailyViews).sum}
              </span>
              <br />
              <span className="stat-label">Views Last 7 Days</span>
            </div>

           

            {/* Dynamically Add Views for Each Year */}
            {Object.keys(viewstats.yearlyViews).map((year) => (
              <div key={year} className="stats-card">
                <span className="stat-value">
                  {viewstats.yearlyViews[year]}
                </span>
                <br />
                <span className="stat-label">Views in {year}</span>
              </div>
            ))}
          </div>

          <div className="row stats-container">
            <div className="stats-card">
              <span className="stat-value">{stats.totalEnquiries}</span>
              <br />
              <span className="stat-label">Total Enquiries</span>
            </div>
            <div className="stats-card">
              <span className="stat-value">{stats.closedLeads}</span>
              <br />
              <span className="stat-label">Closed Leads</span>
            </div>
            <div className="stats-card">
              <span className="stat-value">{stats.openLeads}</span>
              <br />
              <span className="stat-label">Open Leads</span>
            </div>
            <div className="stats-card">
              <span className="stat-value">{stats.leadsThisYear}</span>
              <br />
              <span className="stat-label">Leads This Year</span>
            </div>
            <div className="stats-card">
              <span className="stat-value">{stats.leadsThisMonth}</span>
              <br />
              <span className="stat-label">Leads This Month</span>
            </div>
            <div className="stats-card">
              <span className="stat-value">{stats.leadsLast7Days}</span>
              <br />
              <span className="stat-label">Leads Last 7 Days</span>
            </div>
          </div></>
 {enquiries.length > 0 ? ( 
  <>
          <div className="row align-items-end mt-20 mb-20">
            <div className="col-lg-5">
              <div className="section-title mb-30">
                <span
                  className="sub-title wow fadeInRight"
                  data-wow-duration=".7s"
                >
                  Core Leads
                </span>
                <h3 className="title xb-split-text split-in-right">
                  All Leads <br /> <span>or Messages</span>
                </h3>
              </div>
            </div>
            <div className="col-lg-7">
              <div className="portfolio-menu mb-65 text-lg-end">
                <button
                  className={filter === "all" ? "active" : ""}
                  onClick={() => setFilter("all")}
                >
                  All Leads
                </button>
                <button
                  className={filter === "open" ? "active" : ""}
                  onClick={() => setFilter("open")}
                >
                  Open Leads
                </button>
                <button
                  className={filter === "closed" ? "active" : ""}
                  onClick={() => setFilter("closed")}
                >
                  Closed Leads
                </button>
              </div>
            </div>
          </div>
          <table className="special-admin-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Name</th>
                <th>Email</th>
                <th>Mobile</th>
                <th>Company</th>
                <th>Message</th>
                <th>Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredEnquiries
                .sort((a, b) => new Date(b.date) - new Date(a.date))
                .map((enquiry, index) => (
                  <tr key={enquiry._id} className={`unique-tr-${enquiry._id}`}>
                    <th scope="row">{index + 1}</th>
                    <td>{enquiry.name}</td>
                    <td>{enquiry.email}</td>
                    <td>{enquiry.mobile}</td>
                    <td>{enquiry.company}</td>
                    <td>{enquiry.message}</td>
                    <td>
                      {new Date(enquiry.date).toLocaleDateString()}{" "}
                      {new Date(enquiry.date).toLocaleTimeString()}
                    </td>
                    <td
                      style={{
                        border: "1px solid #ddd",
                        padding: "8px",
                        display: "flex",
                        gap: "10px",
                      }}
                    >
                      {enquiry.leadClosed ? (
                        " "
                      ) : (
                        <img
                          src={tick}
                          id={`close-lead-${enquiry._id}`}
                          style={{ width: "30px", cursor: "pointer" }}
                          alt="Close Lead"
                          onClick={() => handleAction(enquiry._id, "close")}
                        />
                      )}
                      <img
                        src={bin}
                        style={{ width: "30px", cursor: "pointer" }}
                        alt="Delete Lead"
                        onClick={() => handleAction(enquiry._id, "delete")}
                      />
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </>
      ): (
        <>
        <h2 className="mt-40 "><center>
       Sorry! No Leads Available!</center>
        </h2>
        </>)}
    </div>
  );
}

export { Login, AdminDashboard };
